import { useFeatureFlag } from "@/query/hooks/useFeatureFlags";

export function useTransportMode(): boolean {
  return useFeatureFlag("transportMode") === true;
}
